import React, { useCallback } from 'react';
import cn from 'classnames';

import LettersInputFormik, { LettersInputProps } from './LettersInputFormik';
import styles from './StateInputFormik.less';

type Props = LettersInputProps;

const StateInputFormik: React.FC<Props> = ({ className, ...props }) => {
  const transformValue = useCallback((value: string): string => {
    return value.toUpperCase();
  }, []);

  return (
    <LettersInputFormik
      className={cn(styles.input, className)}
      {...props}
      maxLength={2}
      transformValue={transformValue}
    />
  );
};

export default StateInputFormik;
